<template>
  <transition name="modal">
    <div
      class="modal_wrapper"
      :style="dark_theme ?
      'background-color:rgba(0, 0, 0, 0.5);' :
      'background-color: rgba(255, 255, 255, 0.1);'"
      @click="$emit('close')"
    >
      <span v-if="bigCross" class="button-close_big cp posa" @click="$emit('close')" id="btn-close">
        <i class="icon-cross fz36"></i>
      </span>
      <div
        class="modal-content v-popup"
        @click.stop
        :style="`width: ${width};
                height: ${height};
                min-height: ${minHeight};
                min-width: ${minWidth};
                max-height: ${maxHeight};
                max-width: ${maxWidth};
                background-color: ${bgc};
                border-radius: ${bdrs};
                box-shadow:${dark_theme ? 'none !important' : ''};
                ${overflowY ? 'overflow-Y: auto' : ''};
                `"
      >
        <div v-if="!bigCross" class="modal-header">
          <span class="button-close" @click="$emit('close')" id="btn-close"><i class="icon-close-big fz15 main-color-2"></i></span>
        </div>

        <div class="modal-body">
          <slot name="body">default body</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    },
    minWidth: {
      type: String,
      default: "auto"
    },
    minHeight: {
      type: String,
      default: "auto"
    },
    maxWidth: {
      type: String,
      default: "auto"
    },
    maxHeight: {
      type: String,
      default: "auto"
    },
    bgc: {
      type: String,
      default: "#fff"
    },
    bdrs: {
      type: String,
      default: "5px"
    },
    removeCross: Boolean,
    dark_theme: Boolean,
    bigCross: Boolean,
    overflowY: Boolean
  },
  data() {
    return {};
  },
  mounted() {
    document.body.addEventListener("keyup", this.closeModal);
  },
  beforeDestroy() {
    document.body.removeEventListener("keyup", this.closeModal);
  },
  computed: {},
  methods: {
    closeModal(e) {
      if (e.keyCode === 13) {
        return;
      }
      if (e.keyCode === 27) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
// Animation
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: translateY(-10%);
}

.modal-content {
  max-width: 95%;
  max-height: 95%;
  &::-webkit-scrollbar-track {
    background-color: $soft;
    border-radius: 4px;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: $text-soft-light;
    border-radius: 4px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: darken($text-soft-light, 5%);
  }
}

.modal_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.2s ease;
  right: 0;
  z-index: 1010;
}
.modal-header {
  display: inline-block;
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  opacity: 0.4;
  height: 16px;
  z-index: 1;
  &:hover {
    opacity: 1;
  }
  span {
    // font-size: 1.6rem;
    // @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    //   font-size: 2.6rem;
    // }
  }
  .button-close {
    cursor: pointer;
    color: #959595;
    height: 100%;
  }
}
.button-close_big {
  top: 56px;
  right: 65px;
  z-index: 20;
  .icon-cross {
    color: #ffffff;
    opacity: 0.5;
    &:hover {
      opacity: 0.75;
    }
  }
}

.modal-body {
  height: 100%;
}
</style>